import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import { SliderWrapper } from '@/components/ui';
import { BrandArrow } from '@/components/SvgComponents';
import useSlickPositioning from '@/hooks/useSlickPositioning';

import EshopItems from '../EshopItems/EshopItems';

import styles from './EshopSlider.module.scss';

const EshopSlider = ({ data }) => {
  useSlickPositioning();

  return (
    <div
      className='wrapper section'
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={styles.shop_wrapper}>
        <p className={styles.title}>{data?.title}</p>
        <Link href={data?.slug}>
          <a
            title={data?.title}
            aria-label={data?.title}
            className={styles.link}
          >
            <div className={styles.button_container}>
              <span className={styles.link_text}>{data?.button_text}</span>
              <Image
                src='/assets/Arrow.png'
                alt='arrow icon'
                title='Arrow Icon'
                width={20}
                height={20}
              />
            </div>
          </a>
        </Link>
        <SliderWrapper
          arrows
          nextArrow={<BrandArrow width={17} />}
          prevArrow={<BrandArrow width={17} />}
          options={{ infinite: true, slidesToShow: 4 }}
        >
          {data?.product_variations?.map((product, index) => (
            <EshopItems key={index} product={product} />
          ))}
        </SliderWrapper>
      </div>
    </div>
  );
};

export default EshopSlider;
